<template>
  <d2-container>
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="grid-content bg-purple">用户id： {{listObiect.id}}</div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">靓号id：{{listObiect.specificCode}}</div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">昵称：{{listObiect.nickname}}</div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">手机号：{{listObiect.mobile}}</div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="grid-content bg-purple">经验值：{{listObiect.pointAmount}}</div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">配对用户昵称：{{listObiect.matchUserName}}</div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">配对时间：{{listObiect.matchTime}}</div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">等级：{{listObiect.levelName}}</div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="grid-content grid-contens bg-purple">微信手机号：{{listObiect.wechatMobile}}</div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content grid-contens bg-purple">创建时间：{{listObiect.createTime}}</div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content grid-contens bg-purple">
          头像：
          <div>
            <img :src="listObiect.avatar" alt class="imsg" />
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content grid-contens bg-purple">
          配对用户头像：
          <div>
            <img :src="listObiect.matchUserAvatar" alt class="imsg" />
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="grid-content grid-contens bg-purple">微信昵称: {{listObiect.wechatName}}</div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content grid-contens bg-purple">unionId: {{listObiect.unionId}}</div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content grid-contens bg-purple">小程序openId: {{listObiect.miniOpenId}}</div>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top:10px">
      <el-col :span="24">
        <div class="grid-content bg-purple">优惠券：</div>
      </el-col>
    </el-row>
    <el-table
      size="small"
      :key="tableKey"
      :data="list"
      stripe
      border
      highlight-current-row
      style="max-width: 1602px;margin-top: 20px"
    >
      <el-table-column align="center" label="id" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.id}}</span>
        </template>
      </el-table-column>
      <el-table-column width="160" align="center" label="名称">
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column width="150" align="center" label="介绍">
        <template slot-scope="scope">
          <span>{{scope.row.introduce}}</span>
        </template>
      </el-table-column>
      <el-table-column width="120" align="center" label="满减金额">
        <template slot-scope="scope">
          <span>{{scope.row.reduceCost}}</span>
        </template>
      </el-table-column>
      <el-table-column width="120" align="center" label="起用金额">
        <template slot-scope="scope">
          <span>{{scope.row.leastCost}}</span>
        </template>
      </el-table-column>
      <el-table-column width="190" align="center" label="开始时间">
        <template slot-scope="scope">
          <span>{{scope.row.startTime}}</span>
        </template>
      </el-table-column>
      <el-table-column width="190" align="center" label="结束时间">
        <template slot-scope="scope">
          <span>{{scope.row.endTime}}</span>
        </template>
      </el-table-column>
      <el-table-column width="170" align="center" label="使用类型">
        <template slot-scope="scope">
          <span>{{scope.row.type == 1 ? '全场赠券' : (scope.row.type == 2) ? '会员赠券' : (scope.row.type == 3) ? '购物赠券' :(scope.row.type == 4) ? '注册赠券' :'后台发放'}}</span>
        </template>
      </el-table-column>
      <el-table-column width="170" align="center" label="限额数量">
        <template slot-scope="scope">
          <span>{{scope.row.limitCount}}</span>
        </template>
      </el-table-column>
      <el-table-column width="170" align="center" label="状态">
        <template slot-scope="scope" style="color:red">
          <span
            :class="scope.row.stat == 0 ? 'blue' : (scope.row.stat == 1) ? 'green' : (scope.row.stat == 2) ? 'black' : 'red' "
          >{{scope.row.stat == 0 ? '编辑状态' : (scope.row.stat == 1) ? '已发布' : (scope.row.stat == 2) ? '可使用' : '已下架'}}</span>
        </template>
      </el-table-column>
    </el-table>
  </d2-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { getAccountInfo } from '@/api/demo/user/index'
import { getCoupon } from '@/api/demo/writeOff/index'
export default {
  name: 'userDetails',
  data () {
    return {
      listObiect: {},
      tableKey: 0,
      list: [], // 数据
      listQuery: {
        currentPage: 1,
        pageSize: 40,
        accountId: ''
      }
    }
  },
  computed: {
    ...mapGetters(['elements'])
  },
  created () {
    let that = this
    let id = this.$route.query.id
    getAccountInfo(id).then(res => {
      that.listObiect = res
    })
    that.listQuery.accountId = id
    getCoupon(that.listQuery).then(res => {
      that.list = res.records
    })
  },
  mounted () {},
  methods: {}
}
</script>
<style scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #ebf1f6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 50px;
  line-height: 50px;
  padding-left: 20px;
  color: #606266;
  font-size: 14px;
  display: flex;
  align-items: center;
}
.grid-contens {
  min-height: 78px;
  line-height: 78px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.imsg {
  width: 58px;
  display: block;
  margin: 0px auto;
  margin-top: 10px;
  margin-bottom: 10px;
  object-fit: cover;
}
.red {
  color: red;
}
.blue {
  color: blue;
}
.black {
  color: black;
}
.green {
  color: green;
}
</style>
